import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const testimonialsPerPage = 6;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  
  const indexOfLastTestimonial = currentPage * testimonialsPerPage;
  const indexOfFirstTestimonial = indexOfLastTestimonial - testimonialsPerPage;
  const currentTestimonials = testimonials.slice(indexOfFirstTestimonial, indexOfLastTestimonial);
  
  const nextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };
  
  const prevPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };
  
  return (
    <section id="temoignages" className="py-16 md:py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.pexels.com/photos/7267681/pexels-photo-7267681.jpeg"
          alt="Testimonials Background"
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black"></div>
      </div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            <span className="gold-text">Témoignages</span> de Clients Satisfaits
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto serif-font">
            Plus de 150 témoignages authentiques de personnes ayant retrouvé le bonheur
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {currentTestimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="card-hover glass rounded-3xl p-8 relative"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <Quote className="absolute top-6 right-6 text-yellow-500/20" size={48} />
              
              <div className="flex items-center space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} className="text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              
              <p className="text-gray-300 mb-6 leading-relaxed italic text-lg">
                "{testimonial.text}"
              </p>
              
              <div className="flex justify-between items-center pt-4 border-t border-white/10">
                <div>
                  <p className="text-white font-bold text-lg">{testimonial.name}</p>
                  <p className="text-yellow-500 text-sm">{testimonial.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex justify-center items-center space-x-6">
          <button
            onClick={prevPage}
            disabled={currentPage === 1}
            className="glass hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed text-white p-4 rounded-full transition-all disabled:hover:bg-transparent"
          >
            <ChevronLeft size={28} />
          </button>
          
          <div className="glass px-8 py-3 rounded-full">
            <span className="text-white font-semibold text-lg">
              Page <span className="gold-text">{currentPage}</span> sur {totalPages}
            </span>
          </div>
          
          <button
            onClick={nextPage}
            disabled={currentPage === totalPages}
            className="glass hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed text-white p-4 rounded-full transition-all disabled:hover:bg-transparent"
          >
            <ChevronRight size={28} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;